import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './components/app.component';
import { HeaderComponent } from './components/header.component';
import { InputComponent } from './components/input.component';
import { CanvasComponent } from './components/canvas.component';
import { HistoryComponent } from './components/history.component';
import { BlocksComponent } from './components/blocks.component';
import { WatchComponent } from './components/watch.component';
import { CanvasService } from './services/canvas.service';
import { LoginService } from './services/login.service';
import { LanguageService } from './services/language.service';
import { EditorContentService } from './services/editorcontent.service';
import { CommandsService } from './services/commands.service';
import { TurtleService } from './services/turtle.service';
import { StorageService } from './services/onlinestorage.service';
import { SessionStorageService } from './services/sessionstorage.service';
import { DebuggerService } from './services/debugger.service';
import { WatchService } from './services/watch.service';
import { EditorComponent } from './components/editor.component';
import { ExamService } from './services/exam.service';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    InputComponent,
    CanvasComponent,
    HistoryComponent,
    WatchComponent,
    EditorComponent,
    BlocksComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule
  ],
    providers: [CanvasService,
        LoginService,
        LanguageService,
        EditorContentService,
        CommandsService,
        TurtleService,
        StorageService,
        SessionStorageService,
        DebuggerService,
        WatchService,
        ExamService],

  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts